import React from "react";
import { Checkbox, Modal } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";

export const BulkHeaderCheckbox = ({ selection, disabled }) => (
  <Checkbox
    checked={selection.allChecked}
    indeterminate={selection.indeterminate}
    disabled={disabled}
    title="Select all filtered"
    onChange={(e) => selection.toggleAll(e.target.checked)}
  />
);

export const BulkRowCheckbox = ({ selection, id }) => (
  <Checkbox
    checked={selection.isSelected(id)}
    onChange={() => selection.toggle(id)}
  />
);

export const BulkActionBar = ({
  selection,
  noun = "rows",
  actionText = "Delete selected",
  confirmTitle,
  confirmContent = "You will not be able to undo this action",
  onConfirm,
  loading,
}) => {
  if (!selection.count) return null;

  const openConfirm = () =>
    Modal.confirm({
      title: confirmTitle || `Delete ${selection.count} ${noun}?`,
      icon: <ExclamationCircleOutlined className="text-primary" />,
      content: confirmContent,
      okText: actionText,
      okButtonProps: { danger: true },
      onOk() {
        onConfirm(selection.payload);
      },
    });

  return (
    <div
      className="d-flex align-items-center mt-3 px-3 py-2"
      style={{ background: "#F0F7FF", borderRadius: 4, gap: 16 }}
    >
      <span>
        {selection.allFiltered ? `All filtered ${noun} selected: ` : "Selected: "}
        <b>{selection.count}</b>
      </span>
      <button
        type="button"
        className="btn btn-sm btn-link p-0"
        onClick={selection.clear}
      >
        Clear selection
      </button>
      <button
        type="button"
        className="btn btn-sm btn-danger ml-auto"
        disabled={loading}
        onClick={openConfirm}
      >
        {actionText}
      </button>
    </div>
  );
};
